
import request from "@/utils/request";

export default {
  getQspiFacilityList: (param) => {
    return request({
      url: `/qspiFacility/qspiFacilityList`,
      method: "post",
      data: param,
    });
  },
  getQspiFacilityDetail: (tmQspiFacilityId) => {
    return request({
      url: `/qspiFacility/findQspiFacilityDetail/${tmQspiFacilityId}`,
      method: "post",
    });
  },
  saveQspiFacility: (param) => {
    return request({
      url: `/qspiFacility/modifyQspiFacility`,
      method: "post",
      data: param,
    });
  },
  getQspiDcList: (param) => {
    return request({
      url: `/qspiDc/qspiDcList`,
      method: "post",
      data: param,
    });
  },
  changeQspiDcToActive: (param) => {
    return request({
      url: `/qspiDc/changeQspiDcToActive`,
      method: "post",
      data: param,
    });
  },
  changeQspiDcToInactive: (param) => {
    return request({
      url: `/qspiDc/changeQspiDcToInactive`,
      method: "post",
      data: param,
    });
  },
  // 生成评分
  createFactorScore: (param) => {
    return request({
      url: `/qspiFacilityFactorScore/createFactorScore`,
      method: "post",
      data: param,
    });
  },
  // 删除评分
  removeFactorScore: (param) => {
    return request({
      url: `/qspiFacilityFactorScore/removeFactorScore`,
      method: "post",
      data: param,
    });
  },
  // dc生成评分
  generateScore: (param) => {
    return request({
      url: `/qspiDc/generateScore`,
      method: "post",
      data: param,
    });
  },
  // dc删除评分
  deleteScore: (param) => {
    return request({
      url: `/qspiDc/deleteScore`,
      method: "post",
      data: param,
    });
  },
};
